import { Avatar, Divider, ButtonBase } from '@material-ui/core';
import Button from '@material-ui/core/Button';
import CardContent from '@material-ui/core/CardContent';
import { AddRounded, CheckCircleRounded, CloseRounded, DescriptionRounded, FolderRounded, MailRounded, PeopleAltRounded, PhoneRounded, ReceiptRounded, RoomRounded, SchoolRounded } from '@material-ui/icons';
import { getInfosDashboard, deleteRelation } from '@webapps/business';
import { useQuery, useMutation, useRouter, useToast } from '@webapps/reactjs-tech-components';
import { useStyles } from '@webapps/styles';
import { ROUTES_PATH } from 'config/constants';
import Modal from 'components/Modal';
import { useEffect, useState } from 'react';
import { FormattedMessage } from 'react-intl';
import { formatPhoneNumber } from 'react-phone-number-input';

import { useHistory } from 'react-router-dom';
import RelationsCardSkeleton from './RelationsCardSkeleton';

const RelationsCard = ({ info, refetch, isLoading = false }) => {
  const {
    classes,
    css,
    global,
    cx,
    theme: { spacing },
  } = useStyles(styles);

  const { addToast } = useToast();

  const { push: pushState } = useHistory();
  const { push } = useRouter();

  const [open, setOpen] = useState(false);

  const { data: dashboardInfo = {} } = useQuery(getInfosDashboard, {
    key: ['infoDashboardSchool', info?.school?.id],
    variables: { id: info?.school?.id },
    enabled: !isLoading
  });

  const profileImage = dashboardInfo?.profile?.profileImageUrl || info?.profileImageUrl;

  const {
    isLoading: isLoadingDelete,
    isSuccess,
    isError,
    mutateAsync: mutateDeleteRelation,
  } = useMutation(deleteRelation);

  useEffect(() => {
    if (isSuccess && !isLoading) {
      addToast({
        status: 'success',
        message: 'Relation supprimée avec succès',
        autoDismiss: true,
      });
      refetch();
      setOpen(false);
    } else if (isError && !isLoading) {
      addToast({
        status: 'error',
        message: 'Erreur lors de la suppression de la relation',
        autoDismiss: true,
      });
    }
  }, [isSuccess, isError, isLoading]);

  // Return skeleton if loading
  if (isLoading) {
    return <RelationsCardSkeleton />;
  }

  return (
    <div className={classes.container}>
      <CardContent className={css({ textAlign: 'center', padding: spacing(0, 0, 2.5, 0) })}>
        <div className={css({ display: 'flex', justifyContent: 'space-between' })}>
          <div className={classes.photo}>
            <div>
              {profileImage ? (
                <Avatar className={classes.avatar} src={profileImage} />
              ) : (
                <Avatar className={classes.avatar}>
                  {info?.school?.name?.substr(0, 1)}
                </Avatar>
              )}
            </div>
            <div>
              <div className={cx(global.title, classes.name, css({ marginBottom: "10px" }))}>
                {info?.school?.name}
              </div>
              <div className={cx(classes.name, global.infoText, global.frac)} >
                <RoomRounded className={global.smallIcon} />
                <div>{info?.school?.address?.cityCode} {info?.school?.address?.city}</div>
              </div>
            </div>
          </div>
          <div>
            <ButtonBase onClick={() => setOpen(true)} className={global.buttonBase}>
              <CloseRounded className={global.buttonIcon} />
            </ButtonBase>
          </div>
        </div>
        <div className={cx(global.infoText, classes.address)}>
          <SchoolRounded className={global.infoIcon} />
          <div>{`${info?.totalTrainings} Formations`}  {info?.totalTrainingsToComplete > 0 && <span className={classes.toComplete}>{`${info?.totalTrainingsToComplete} formations à compléter`}</span>}</div>
        </div>
        <div className={cx(global.infoText, classes.address)}>
          <FolderRounded className={global.infoIcon} />
          <div>{`${info?.totalOpcoRecords} Dossiers OPCO`}</div>
        </div>
        <div className={cx(global.infoText, classes.address)}>
          <ReceiptRounded className={global.infoIcon} />
          <div>{`${info?.totalBillings} Factures`}</div>
        </div>
        <Divider className={classes.divider} />
        <div className={cx(global.infoText, classes.address)}>
          <PeopleAltRounded className={global.infoIcon} />
          <div>{`${info?.totalStudents} Apprenants`}</div>
        </div>
        <div className={cx(global.infoText, classes.address)}>
          <CheckCircleRounded className={global.infoIcon} />
          <div>{`${info?.totalStudentsBusiness} Apprenants en entreprise`}</div>
        </div>
        <div className={cx(global.infoText, classes.address)}>
          <DescriptionRounded className={global.infoIcon} />
          <div>{`${info?.totalContractToSend} Contrat à envoyer`}</div>
        </div>
        <div className={cx(global.infoText, classes.address)}>
          <DescriptionRounded className={global.infoIcon} />
          <div>{`${info?.totalContractAwaiting} Contrat en attente des autres parties`}</div>
        </div>
        <Divider className={classes.divider} />
        <div className={cx(global.infoText, classes.address)}>
          <MailRounded className={global.infoIcon} />
          <div>{info?.school?.email}</div>
        </div>
        <div className={cx(global.infoText, classes.address)}>
          <PhoneRounded className={global.infoIcon} />
          <div>{info?.school?.phone ? formatPhoneNumber(info?.school?.phone) : 'Non renseigné'}</div>
        </div>
      </CardContent>
      <div className={classes.buttons}>
        <Button
          onClick={() => pushState(ROUTES_PATH.CFA_ORGANISMES, { schoolId: info.school.id, refresh: true })}
          className={global.greyButton}
          variant="outlined"
        >
          Voir les formations
        </Button>
        <Button
          onClick={() => push(ROUTES_PATH.SCHOOL_VITRINE, { params: { id: info.school.id } })}
          className={global.greyButton}
          variant="outlined"
        >
          <FormattedMessage id="vitrine.btnVoirEtablissement" />
        </Button>
      </div>
      <Modal
        onCancel={() => setOpen(false)}
        open={open}
        title="Contacter le support"
        withStep={false}
      >
        {/* <Button
          onClick={async () => await mutateDeleteRelation({ id: info.id, from: "cfa" })}
          variant="contained"
          color="secondary"
        >
          Confirmer
        </Button> */}
        <div>Pour supprimée cette organisme de formation veuillez contacter le support <strong>support@linkpick.fr</strong></div>
        <Button
          onClick={() => setOpen(false)}
          variant="contained"
          color="primary"
        >
          Ok
        </Button>
      </Modal>
    </div>
  );
};

const styles = ({ spacing }) => ({
  container: {
    backgroundColor: "white",
    borderRadius: 16,
    padding: spacing(2.5),
  },
  buttonsContainer: {
    display: 'flex',
    columnGap: 10,
  },
  name: {
    marginLeft: spacing(2),
    display: 'flex',
    textAlign: 'start',
    fontFamily: 'Montserrat',
    wordBreak: 'break-all',
  },
  divider: {
    margin: "8px 0px",
  },
  address: {
    display: 'flex',
    marginTop: spacing(0.5),
    textAlign: 'start',
    alignItems: 'center',
  },
  avatar: {
    height: 60,
    width: 60,
    border: '1px solid #C0D9FF',
  },
  photo: {
    marginBottom: spacing(2),
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  buttons: {
    display: 'flex',
    flexDirection: 'column',
    marginTop: 'auto',
    rowGap: 10,
  },
  toComplete: {
    backgroundColor: '#F50057',
    color: "white",
    fontSize: 11,
    padding: "2px 5px",
    marginLeft: '5px',
    borderRadius: '4px',
  }
});

export default RelationsCard;
